import { Injectable } from '@angular/core';
import { CommonService } from './services/common.service';

@Injectable({
  providedIn: 'root',
})
export class commonfuctionService {
  processData(data: string): string {
    return `Processed data: ${data}`;
  }
 constructor(private commonService:CommonService) {


 }
  maskMobileOrEmail(input: string, flag: number): string {
    if (flag === 1) {
      // Email masking
      const [username, domain] = input.split('@');
      if (!domain) return input; // Invalid email
      if (username.length <= 2) {
        return '*'.repeat(username.length) + '@' + domain;
      }
      const firstChar = username.charAt(0);
      const lastChar = username.charAt(username.length - 1);
      const maskedMiddle = '*'.repeat(username.length - 2);
      return `${firstChar}${maskedMiddle}${lastChar}@${domain}`;
    }
  
    if (flag === 2) {
      // Mobile masking
      return input.length === 10
        ? input.replace(/^(\d{2})\d{6}(\d{2})$/, '$1XXXXXX$2')
        : input;
    }
  
    return input;
  }
//   CheckDuplicateEmailOrMobile(emailId: string, mobile: string): Promise<any> {
//     return new Promise((resolve, reject) => {
//       this.commonService
//         .CheckDuplicateEmailOrMobile(emailId, mobile)
//         .subscribe(
//           (response) => {
//             if (response.status === 200) {
//               resolve(response.data);
//             } else {
//               reject(response.message);
//             }
//           },
//           (error) => {
//             reject(error);
//           }
//         );
//     });
//   }
  // checkEmailOrMobile(emailId: string, mobile: string){
  //   this.commonService.CheckDuplicateEmailOrMobile(emailId, mobile).subscribe((response) => {
  //      
  //     if (response.status === 200) {
  //       return response;
  //     } else {
  //       console.error('Error:', response.message);
  //       return null;
  //     }
  //   });

  // }
  
}